import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { UserService } from '../../../../Service/User/user.service';
import { UserFormStateService } from '../../Service/formStateService';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
import { CustomDatepickerTypeComponent } from '../../../../Formly/custom-types/custom-datepicker.type';

@Component({
  selector: 'app-add-tyre-battery-details',
  templateUrl: './add-tyre-battery-details.component.html',
  styleUrls: ['./add-tyre-battery-details.component.scss'],
})
export class AddTyreBatteryDetailsComponent implements OnInit, OnDestroy {
  countryId: any;
  form = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  weeks: { label: string; value: string }[] = [];
  years: { label: string; value: string }[] = [];

  @Output() nextSection = new EventEmitter<void>();
  @Output() formValidity = new EventEmitter<boolean>();
  isFormPopulated: boolean = false;

  receivedObject: any;
  constructor(
    private api: UserService,
    private formStateService: UserFormStateService,
    private serviceAPI: ServiceProviderService,
    private cdr: ChangeDetectorRef,
    private formlyConfig: FormlyConfig
  ) {}

  ngOnInit(): void {
    this.loadFormData();
    this.initializeField();
    this.generateDateCodes();

    if (!this.formlyConfig.getType('custom-dt')) {
      this.formlyConfig.setType({
        name: 'custom-dt',
        component: CustomDatepickerTypeComponent,
      });
    }
  }

  ngOnDestroy() {
    this.saveFormData();
  }

  saveFormData() {
    const transformedData = this.transformFormData(this.form.value);
    this.formStateService.setTyreBatteryDetails(transformedData);
    this.formStateService.setFormData('tyre-battery', this.form.value);
    console.log('Saved form data:', this.form.value);
  }

  loadFormData() {
    const savedData = this.formStateService.getFormData('tyre-battery');
    if (savedData) {
      this.model = savedData;
      this.form.patchValue(savedData);
      this.isFormPopulated = true;
      console.log('Loaded saved data:', savedData);
    }
  }
  resetForm() {
    this.form.reset();
    this.model = {};
  }
  generateDateCodes() {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;

    // Generate weeks from 01 to 52
    for (let week = 1; week <= 52; week++) {
      const weekStr = week.toString().padStart(2, '0');
      this.weeks.push({ label: `${weekStr}`, value: weekStr });
    }

    // Generate years from startYear to currentYear
    for (let year = startYear; year <= currentYear; year++) {
      this.years.push({ label: `${year}`, value: `${year}` });
    }
  }

  initializeField(): void {
    this.fields = [
      ...this.frh(),
      ...this.flh(),
      ...this.rrh(),
      ...this.rhl(),
      ...this.spareParts(),
      ...this.batteryDetails(),
      ...this.engineOilDetails(),
    ];
  }

  frh(): FormlyFieldConfig[] {
    return [
      {
        template: '<div class="font-semibold mt-6">Tyre Details</div>',
      },
      {
        template:
          '<div class="font-semibold text-base mt-6 mb-4 text-500">FRH</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'frhspecification',
            type: 'input',
            templateOptions: {
              label: 'Specification',
              placeholder: 'Enter FRH Specification',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Specification.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'frhBrandName',
            type: 'input',
            templateOptions: {
              label: 'Brand Name',
              placeholder: 'Enter FRH Brand',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Brand Name.',
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'frhType',
            type: 'select',
            templateOptions: {
              options: this.api.getTyreTypes(),
              label: 'Type',
              placeholder: 'Enter FRH Type',
              required: true,
              hideRequiredMarker: true,
              valueProp: 'tyreTypeId',
              labelProp: 'name',
              change: (field, $event) => {
                console.log('Selected tyre type:', $event.value);
              },
            },
            validation: {
              messages: {
                required: 'Enter Type.',
              },
            },
          },
          {
            className: 'field col-2',
            key: 'frhWeek',
            type: 'select',
            templateOptions: {
              options: this.weeks,
              label: 'Week',
              placeholder: 'Select Week',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Week.',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'frhYear',
            type: 'select',
            templateOptions: {
              options: this.years,
              label: 'Year',
              placeholder: 'Select Year',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Year.',
              },
            },
          },
        ],
      },
    ];
  }

  flh(): FormlyFieldConfig[] {
    return [
      {
        template:
          '<div class="font-semibold text-base mt-5 mb-4 text-500">FLH</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'flhSpecification',
            type: 'input',
            templateOptions: {
              label: 'Specification',
              placeholder: 'Enter FLH Specification',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Specification.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'flhBrandName',
            type: 'input',
            templateOptions: {
              label: 'Brand Name',
              placeholder: 'Enter FLH Brand',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Brand Name.',
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'flhType',
            type: 'select',
            templateOptions: {
              options: this.api.getTyreTypes(),
              label: 'Type',
              placeholder: 'Enter FLH Type',
              required: true,
              hideRequiredMarker: true,
              valueProp: 'tyreTypeId',
              labelProp: 'name',
              change: (field, $event) => {
                console.log('Selected tyre type:', $event.value);
              },
            },
            validation: {
              messages: {
                required: 'Enter Type.',
              },
            },
          },
          {
            className: 'field col-2',
            key: 'flhWeek',
            type: 'select',
            templateOptions: {
              options: this.weeks,
              label: 'Week',
              placeholder: 'Select Week',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Week.',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'flhYear',
            type: 'select',
            templateOptions: {
              options: this.years,
              label: 'Year',
              placeholder: 'Select Year',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Year.',
              },
            },
          },
        ],
      },
    ];
  }

  rrh(): FormlyFieldConfig[] {
    return [
      {
        template:
          '<div class="font-semibold text-base mt-5 mb-4 text-500">RRH</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'rrhSpecification',
            type: 'input',
            templateOptions: {
              label: 'Specification',
              placeholder: 'Enter RRH Specification',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Specification.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'rrhBrandName',
            type: 'input',
            templateOptions: {
              label: 'Brand Name',
              placeholder: 'Enter RRH Brand',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Brand Name',
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'rrhType',
            type: 'select',
            templateOptions: {
              options: this.api.getTyreTypes(),
              label: 'Type',
              placeholder: 'Enter RRH Type',
              required: true,
              hideRequiredMarker: true,
              valueProp: 'tyreTypeId',
              labelProp: 'name',
            },
            validation: {
              messages: {
                required: 'Enter Type.',
              },
            },
          },
          {
            className: 'field col-2',
            key: 'rrhWeek',
            type: 'select',
            templateOptions: {
              options: this.weeks,
              label: 'Week',
              placeholder: 'Select week',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Week.',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'rrhYear',
            type: 'select',
            templateOptions: {
              options: this.years,
              label: 'Year',
              placeholder: 'Select Year',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Year.',
              },
            },
          },
        ],
      },
    ];
  }

  rhl(): FormlyFieldConfig[] {
    return [
      {
        template:
          '<div class="font-semibold text-base mt-5 mb-4 text-500">RHL</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'rhlSpecification',
            type: 'input',
            templateOptions: {
              label: 'Specification',
              placeholder: 'Enter RHL Specification',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Specification.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'rhlBrandName',
            type: 'input',
            templateOptions: {
              label: 'Brand Name',
              placeholder: 'Enter RHL Brand',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Brand Name.',
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'rhlType',
            type: 'select',
            templateOptions: {
              options: this.api.getTyreTypes(),
              label: 'Type',
              placeholder: 'Enter RHL Type',
              required: true,
              hideRequiredMarker: true,
              valueProp: 'tyreTypeId',
              labelProp: 'name',
            },
            validation: {
              messages: {
                required: 'Enter Type.',
              },
            },
          },
          {
            className: 'field col-2',
            key: 'rhlWeek',
            type: 'select',
            templateOptions: {
              options: this.weeks,
              label: 'Week',
              placeholder: 'Select week',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Week.',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'rhlYear',
            type: 'select',
            templateOptions: {
              options: this.years,
              label: 'Year',
              placeholder: 'Select Year',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Year.',
              },
            },
          },
        ],
      },
    ];
  }

  spareParts(): FormlyFieldConfig[] {
    return [
      {
        template:
          '<div class="font-semibold text-base mt-5 mb-4 text-500">Spare wheel</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'sparePartSpecification',
            type: 'input',
            templateOptions: {
              label: 'Specification',
              placeholder: "Enter Spare part's Specification",
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Specification.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'sparePartBrandName',
            type: 'input',
            templateOptions: {
              label: 'Brand Name',
              placeholder: "Enter Spare Part's Brand",
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Brand Name.',
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'sparePartType',
            type: 'select',
            templateOptions: {
              options: this.api.getTyreTypes(),
              label: 'Type',
              placeholder: "Select Spare part's Type",
              required: true,
              hideRequiredMarker: true,
              valueProp: 'tyreTypeId',
              labelProp: 'name',
            },
            validation: {
              messages: {
                required: 'Enter Type.',
              },
            },
          },
          {
            className: 'field col-2',
            key: 'sparePartWeek',
            type: 'select',
            templateOptions: {
              options: this.weeks,
              label: 'Week',
              placeholder: 'Select week',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Week.',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'sparePartYear',
            type: 'select',
            templateOptions: {
              options: this.years,
              label: 'Year',
              placeholder: 'Select Year',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Year.',
              },
            },
          },
        ],
      },
    ];
  }

  batteryDetails(): FormlyFieldConfig[] {
    return [
      {
        template:
          '<div class="font-semibold text-base mt-6 mb-4">Battery Details</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'batteryMake',
            type: 'select',
            templateOptions: {
              options: this.api.getBatteryMakers(),
              label: 'Battery Brand',
              placeholder: 'Select Battery Brand',
              required: true,
              hideRequiredMarker: true,
              valueProp: 'batteryMakerId',
              labelProp: 'name',
            },
            validation: {
              messages: {
                required: 'Enter Battery Make.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'batteryModel',
            type: 'input',
            templateOptions: {
              label: 'Battery Model',
              placeholder: 'Enter Battery Model',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Battery Model.',
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'batteryManufactureDate',
            type: 'custom-dt',
            templateOptions: {
              label: 'Battery Mfg',
              placeholder: 'Select Battery Manufacture Date',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Battery Mfg.',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'batteryPurchasedDate',
            type: 'custom-dt',
            templateOptions: {
              label: 'Battery Purchased on',
              placeholder: 'Select a Battery Purchase Date',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Enter Battery Purchased on.',
              },
            },
          },
        ],
      },
    ];
  }
  engineOilDetails(): FormlyFieldConfig[] {
    return [
      {
        template:
          '<div class="font-semibold text-base mt-6 mb-4">Engine Oil Details</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'oilGrade',
            type: 'select',
            templateOptions: {
              options: this.api.getOilGrade(),
              label: 'Engine Oil Grade',
              placeholder: 'Select a Option',
              required: true,
              hideRequiredMarker: true,
              valueProp: 'engineOilGradeId',
              labelProp: 'name',
            },
            validation: {
              messages: {
                required: 'Enter Engine Oil Grade.',
              },
            },
          },
        ],
      },
    ];
  }
  transformFormData(formData: any): any {
    const combineDateCode = (week: string, year: string) => {
      return `${week}/${year}`;
    };

    return {
      tyreDetails: [
        {
          position: 1,
          specification: formData.frhspecification,
          brandName: formData.frhBrandName,
          dateCode: combineDateCode(formData.frhWeek, formData.frhYear),
          tyreTypeId: formData.frhType,
        },
        {
          position: 2,
          specification: formData.flhSpecification,
          brandName: formData.flhBrandName,
          dateCode: combineDateCode(formData.flhWeek, formData.flhYear),
          tyreTypeId: formData.flhType,
        },
        {
          position: 3,
          specification: formData.rrhSpecification,
          brandName: formData.rrhBrandName,
          dateCode: combineDateCode(formData.rrhWeek, formData.rrhYear),
          tyreTypeId: formData.rrhType,
        },
        {
          position: 4,
          specification: formData.rhlSpecification,
          brandName: formData.rhlBrandName,
          dateCode: combineDateCode(formData.rhlWeek, formData.rhlYear),
          tyreTypeId: formData.rhlType,
        },
        {
          position: 5,
          specification: formData.sparePartSpecification,
          brandName: formData.sparePartBrandName,
          dateCode: combineDateCode(
            formData.sparePartWeek,
            formData.sparePartYear
          ),
          tyreTypeId: formData.sparePartType,
        },
      ],
      batteryMakerId: formData.batteryMake?.value ?? formData.batteryMake,
      batteryModel: formData.batteryModel,
      batteryMfg: new Date(formData.batteryManufactureDate),
      batteryPurchasedOn: new Date(formData.batteryPurchasedDate),
      engineOilGradeId: formData.oilGrade,
    };
  }
  onSubmit() {
    this.saveFormData();
    const transformedData = this.transformFormData(this.form.value);
    this.formStateService.setTyreBatteryDetails(transformedData);
    console.log('Transformed data:', transformedData);
    this.nextSection.emit();
  }
  
  populateFormWithServiceSeekersDetails(res: any) {
    if(!this.isFormPopulated){
    const tyreDetails = res?.tyreDetails || [];

    // Populate FRH tyre details
    this.model.frhspecification = tyreDetails[0]?.specification || '';
    this.model.frhBrandName = tyreDetails[0]?.brandName || '';
    this.model.frhType = tyreDetails[0]?.tyreType?.tyreTypeId || '';
    const frhDateCode = tyreDetails[0]?.dateCode ? tyreDetails[0]?.dateCode.split('/') : ['', ''];
    this.model.frhWeek = frhDateCode[0] || '';
    this.model.frhYear = frhDateCode[1] || '';
  
    // Populate FLH tyre details
    this.model.flhSpecification = tyreDetails[1]?.specification || '';
    this.model.flhBrandName = tyreDetails[1]?.brandName || '';
    this.model.flhType = tyreDetails[1]?.tyreType?.tyreTypeId || '';
    const flhDateCode = tyreDetails[1]?.dateCode ? tyreDetails[1]?.dateCode.split('/') : ['', ''];
    this.model.flhWeek = flhDateCode[0] || '';
    this.model.flhYear = flhDateCode[1] || '';
  
    // Populate RRH tyre details
    this.model.rrhSpecification = tyreDetails[2]?.specification || '';
    this.model.rrhBrandName = tyreDetails[2]?.brandName || '';
    this.model.rrhType = tyreDetails[2]?.tyreType?.tyreTypeId || '';
    const rrhDateCode = tyreDetails[2]?.dateCode ? tyreDetails[2]?.dateCode.split('/') : ['', ''];
    this.model.rrhWeek = rrhDateCode[0] || '';
    this.model.rrhYear = rrhDateCode[1] || '';
  
    // Populate RHL tyre details
    this.model.rhlSpecification = tyreDetails[3]?.specification || '';
    this.model.rhlBrandName = tyreDetails[3]?.brandName || '';
    this.model.rhlType = tyreDetails[3]?.tyreType?.tyreTypeId || '';
    const rhlDateCode = tyreDetails[3]?.dateCode ? tyreDetails[3]?.dateCode.split('/') : ['', ''];
    this.model.rhlWeek = rhlDateCode[0] || '';
    this.model.rhlYear = rhlDateCode[1] || '';
  
    // Populate Spare tyre details
    this.model.sparePartSpecification = tyreDetails[4]?.specification || '';
    this.model.sparePartBrandName = tyreDetails[4]?.brandName || '';
    this.model.sparePartType = tyreDetails[4]?.tyreType?.tyreTypeId || '';
    const spareDateCode = tyreDetails[4]?.dateCode ? tyreDetails[4]?.dateCode.split('/') : ['', ''];
    this.model.sparePartWeek = spareDateCode[0] || '';
    this.model.sparePartYear = spareDateCode[1] || '';
  
    // Populate battery details
    this.model.batteryMake = res?.batteryDetails?.batteryMake || '';
    this.model.batteryModel = res?.batteryDetails?.batteryModel || '';
    this.model.batteryManufactureDate = res?.batteryDetails?.batteryManufactureDate
      ? new Date(res?.batteryDetails?.batteryManufactureDate)
      : '';
    this.model.batteryPurchasedDate = res?.batteryDetails?.batteryPurchasedDate
      ? new Date(res?.batteryDetails?.batteryPurchasedDate)
      : '';
  
    // Populate engine oil details
    this.model.oilGrade = res?.engineOilDetails?.oilGrade || '';
  
    this.form.patchValue(this.model);
    this.cdr.detectChanges();
  
    this.isFormPopulated = true;
    this.formStateService.setFormData('tyre-battery', this.model);
  }else{
    console.log('Form already populated, skipping patching')
  }
  }
  
}
